'use client';

import { useEffect } from 'react';

import ErrorState from '@/app/(main)/_components/error-state/error-state';
import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import { getLogger } from '@/logger/logger';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    const logger = getLogger('Error root layout');
    logger.error('Fallback to root layout error', { digest: error.digest }, error);
  });

  return (
    <>
      <Breadcrumb
        list={[
          {
            label: 'Página inicial',
            href: window.location.origin,
          },
        ]}
      />
      <ErrorState onReset={reset} />
    </>
  );
}
